var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Integration-and-Tutorials",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Integrations---III-1280-PX",
    transform: "translate(-768.000000, -183.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "THUMBNAIL",
    transform: "translate(665.000000, 174.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check",
    transform: "translate(103.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-7",
    fill: "#37E291",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5771687,6.14644661 C12.7724308,5.95118446 13.0890133,5.95118446 13.2842755,6.14644661 L13.8535534,6.71572452 C14.0488155,6.91098666 14.0488155,7.22756915 13.8535534,7.4228313 L8.8380729,12.4383118 C8.64281076,12.6335739 8.32622827,12.6335739 8.13096612,12.4383118 L5.14644661,9.45379227 C4.95118446,9.25853013 4.95118446,8.94194764 5.14644661,8.74668549 L5.71572452,8.17740758 C5.91098666,7.98214544 6.22756915,7.98214544 6.4228313,8.17740758 L8.48451951,10.2390958 L12.5771687,6.14644661 Z",
    id: "Line-6",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.ed41f1a34d5e591c9c6eeb6b4a510a5b.svg";
export { ForwardRef as ReactComponent };